import React from 'react';
import PropTypes from 'prop-types';
import {
	Box,
	Divider,
} from '@mui/material';
import SubscriptionForm from './SubscriptionForm';
import SubscriptionList from './SubscriptionList';

function SubscriptionsEditor({ subscriptions, hasDynamicDateRange, onSubscriptionsChange }) {
	const handleAddSubscription = (newSubscription) => {
		// Add temporary id to avoid problems in rendering list (need a unique key)
		newSubscription.id = `temp-${subscriptions.length + 1}`;
		const updatedSubscriptions = [...subscriptions, newSubscription];
		onSubscriptionsChange(updatedSubscriptions);
	};

	const handleDeleteSubscription = (subscriptionListIndex) => {
		const updatedSubscriptions = [...subscriptions];
		updatedSubscriptions.splice(subscriptionListIndex, 1);
		onSubscriptionsChange(updatedSubscriptions);
	};

	return (
		<Box>
			<SubscriptionList
				subscriptions={subscriptions}
				onDeleteSubscription={handleDeleteSubscription}
			/>
			<Divider />
			<SubscriptionForm
				hasDynamicDateRange={hasDynamicDateRange}
				onAddSubscription={handleAddSubscription}
			/>
		</Box>
	);
}

export default SubscriptionsEditor;

function atLeastOneRecipientType(props, propName, componentName) {
	if (!props.userRecipients && !props.emailOnlyRecipients) {
		return new Error(`'${componentName}' must have one of 'userRecipients' or 'emailOnlyRecipients' defined.`);
	}
	return null; // Validation passed
}

SubscriptionsEditor.propTypes = {
	subscriptions: PropTypes.arrayOf(PropTypes.shape({
		userRecipients: PropTypes.arrayOf(PropTypes.shape({
			userId: PropTypes.string.isRequired,
		})),
		emailOnlyRecipients: PropTypes.arrayOf(PropTypes.string),
		atLeastOneRecipientType,
		occurences: PropTypes.arrayOf(PropTypes.shape({
			type: PropTypes.oneOf(['daily', 'weekly', 'monthly', 'yearly']).isRequired,
		})).isRequired,
	})),
	hasDynamicDateRange: PropTypes.func.isRequired,
	onSubscriptionsChange: PropTypes.func.isRequired,
};

SubscriptionsEditor.defaultProps = {
	subscriptions: [],
};
